import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ClearableInput } from "@/components/shared/ClearableInput";
import { AXIS_LABEL } from "@/constants/ab-tests";
import type { AxisKey } from "@/types/ab-tests";

interface CustomAlternativeInputProps {
  axis: AxisKey;
  onSubmit: (text: string) => void;
}

export function CustomAlternativeInput({ axis, onSubmit }: CustomAlternativeInputProps) {
  const [value, setValue] = useState("");
  const trimmed = value.trim();

  const submit = () => {
    if (!trimmed) return;
    onSubmit(trimmed);
    setValue("");
  };

  return (
    <section className="space-y-2.5 border-t border-border pt-6">
      <h5 className="text-base font-semibold leading-6 text-foreground">
        Write your own
      </h5>
      <div className="flex items-center gap-1.5">
        <ClearableInput
          value={value}
          onChange={setValue}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              submit();
            }
          }}
          placeholder={`Type a ${AXIS_LABEL[axis].toLowerCase()} phrase…`}
          className="h-8 text-sm"
          icon={null}
        />
        <Button type="button" variant="default" size="sm" disabled={!trimmed} onClick={submit}>
          Save
        </Button>
      </div>
    </section>
  );
}
